module.exports = __webpack_public_path__ + "img/icreator-conference-2022-logo.252d6f32.png";